import { render, staticRenderFns } from "./SelectView.vue?vue&type=template&id=1564bd40&scoped=true&"
import script from "./SelectView.vue?vue&type=script&lang=js&"
export * from "./SelectView.vue?vue&type=script&lang=js&"
import style0 from "./SelectView.vue?vue&type=style&index=0&id=1564bd40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564bd40",
  null
  
)

export default component.exports